export default {"src":"/_next/static/media/ens.de9fb57a.svg","height":231,"width":202,"blurWidth":0,"blurHeight":0};